import { te } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { Table } from "react-bootstrap";
import Select, { components } from "react-select";

export default function ModalAddInTest(props) {
  const { lang, functions, proxy, database } = useSelector((state) => state);
  const { filterData } = functions;
  const {
    setIsToggle,
    data,
    handleChange,
    fields,
    setRefreshPage,
    setSelectedValues,
    LXH,
  } = props;
  const [resetForm, setResetForm] = useState(0);
  const [selectedSuggest, setSelectedSuggest] = useState([]);
  const [selected, setSelected] = useState([]);
  const [tempValue, setTempValue] = useState({
    alias: "",
    value: {},
  });
  const [inputFields, setInputFields] = useState([
    {
      label: "LXH/LĐĐNB",
      required: true,
      alias: "3LXH",
      readOnly: false,
      type: "text",
      isFK: {
        state: true,
        child: [
          { value: "lenhXuatHangERP", alias: "4LXH" },
          { value: "5SLCXTT" },
          { value: "28MSP", alias: "25MSP" },
          { value: "deliveryDetailId", alias: "deliveryDetailId" },
        ],
      },
    },
    // { label: "Mã Sản Phẩm", alias: "25MSP", readOnly: false, type: "text" },
    // { label: "Số Hóa Đơn", alias: "4SHĐ", type: "text" },
    {
      label: "Số Lượng Tấn Cần Xuất",
      alias: "4SLCXTT",
      type: "number",
      isParamSuggest: true,
    },
    // { label: "Vị Trí Lấy Hàng", alias: "13VTLH", type: "text" },
    {
      label: "Gợi Ý Lệnh Đóng Bao",
      alias: "3MLĐB",
      type: "text",
      isSuggest: true,
      isFK: {
        state: true,
        child: [
          { value: "1MLĐB", alias: "3MLĐB" },
          { value: "", alias: "23MSP" },
          { value: "", alias: ["7SL", "2HSD", "11NSX"] },
          { value: "", alias: "2HSD" },
          { value: "", alias: "11NSX" },
        ],
      },
      child: [
        { label: "Mã Lệnh Đóng Bao", alias: "3MLĐB" },
        { label: "Mã Thành Phẩm", alias: "SP" },
        { label: "Số Lot", alias: "SoLot" },
        { label: "SL Cần Xuất", alias: "SLX", color: "rgb(25, 14, 185)" },
        {
          label: "SL Đóng Bao Chưa Xuất",
          alias: "SLCX",
          color: "rgb(0, 171, 65)",
        },
      ],
    },
    { label: "Ghi Chú", alias: "2GCS", type: "textarea" },
  ]);
  const _token = localStorage.getItem("_token");
  const alias = fields.find((item) => item.isDisplay == false).alias;

  const [paramSuggest, SetParamSuggest] = useState({
    alias: "",
    param: "",
  });
  const [dataSuggest, setDataSuggest] = useState([]);
  const [isData, setData] = useState([]);

  useEffect(() => {
    fetch(`${proxy()}/api/PXK/optionLDB`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        if (data.length > 0) {
          const alias = inputFields.find(
            (item) => item.isSuggest && item.isFK
          ).alias;
          const options = data.map((d) => {
            if (d[alias]) {
              return {
                value: d,
                label: d[alias],
                ...d,
              };
            }
          });
          setData(options);
        }
      });
  }, []);
  const handleCallDataSugges = () => {
    if (paramSuggest.param && paramSuggest.param > 0) {
      fetch(`${proxy()}/api/PXK/ldb/${paramSuggest.param}`, {
        headers: {
          Authorization: _token,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          setDataSuggest(res);
          setSelectedSuggest(res);
          if (res && res.length > 0) {
            if (paramSuggest) {
              const findAlias = inputFields.find(
                (item) => item.isSuggest
              ).alias;
              setTempValue({
                alias: alias,
                value: {
                  ...tempValue.value,
                  [findAlias]: res,
                },
              });
            }
          }
        });
    }
  };
  const loadOptions = async (page = 0, search = "", items, data) => {
    return new Promise(async (resolve, reject) => {
      let dataBody = {
        table_id: 22577,
        start_index: page,
        type: "or",
      };

      let newData = {
        options: [],
        hasMore: false,
        additional: {
          page: 0,
        },
      };
      dataBody["criteria"] = {
        "2MLXH": search.trim(),
        lenhXuatHangERP: search.trim(),
      };
      dataBody["criteria_type"] = {
        "2MLXH": "regex",
        lenhXuatHangERP: "regex",
      };
      try {
        const response = await fetch(`${proxy()}/api/PXK/optionLGH`, {
          method: "POST",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify({
            ...dataBody,
            skip: page,
            limit: 100,
          }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.statusText}`);
        }

        const res = await response.json();
        const returnedData = res.data || [];

        const options = returnedData.map((d) => {
          if (items.child?.length) {
            let label = items.child.map(({ value }) => d[value]).join("|");
            return {
              value: d,
              label: label,
            };
          }
        });

        const hasMoreValue = returnedData.length > 0;
        const aliasSet = new Set(data[alias].map((item) => item["4LXH"]));

        const filteredOptions = options;
        //  options.filter((option) => {
        //   const optionValue = option.value["lenhXuatHangERP" || "2MLXH"];
        //   return !aliasSet.has(optionValue);
        // });
        // const mapped = filteredOptions.map((item, index) => {
        //   const findLXH = LXH.find(
        //     (lxh) => item.value["2MLXH"] === lxh["2MLXH"]
        //   );
        //   if (findLXH) {
        //     return {
        //       ...item,
        //       value: {
        //         ...item.value,
        //         ...findLXH,
        //       },
        //     };
        //   }
        // });
        const mapped = filteredOptions.flatMap((item) => {
          const findLXH = LXH.find(
            (lxh) =>
              item.value["lenhXuatHangERP" || "2MLXH"] ===
                lxh["lenhXuatHangERP" || "2MLXH"] &&
              item.value.delivery_detail_id === lxh.delivery_detail_id
          );
          const hasArrayField = items.child.find(({ value }) =>
            Array.isArray(item.value[value])
          )?.value;

          // let label = items.child
          //   .map(({ value }) => item.value[value])
          //   .join("|");

          if (!hasArrayField) {
            return [
              {
                label: items.child
                  .map((field) => item.value?.[field?.value])
                  .filter(Boolean)
                  .join("|"),
                value: {
                  ...item.value,
                  ...findLXH,
                },
              },
            ];
          }
          const arrayField = hasArrayField;
          const arrayValues = item?.value[arrayField];

          return arrayValues.map((val) => {
            const clonedItem = {
              ...item,
              [arrayField]: val,
              value: { ...item.value, [arrayField]: val },
            };

            return {
              ...findLXH,
              ...clonedItem,
              label: items.child
                .map((field) => clonedItem?.value?.[field.value])
                .filter(Boolean)
                .join("|"),
            };
          });
          // if (findLXH) {
          //   return {
          //     ...item,
          //     value: {
          //       ...item.value,
          //       ...findLXH,
          //     },
          //   };
          // }
        });
        const { PP = [] } = data;
        const mappedData = mapped.filter(
          (item) =>
            !PP.some(
              ({ deliveryDetailId, "4LXH": lxh }) =>
                lxh === item.value["2MLXH"] &&
                deliveryDetailId === item.value.deliveryDetailId
            )
        );

        newData = {
          options: mappedData,
          hasMore: hasMoreValue,
          additional: {
            page: hasMoreValue ? page + 100 : page,
          },
        };
        setTimeout(() => {
          resolve(filterData(newData, search));
        }, 100);
      } catch (error) {
        console.error("Error in loadOptions:", error);
        reject(error);
      }
    });
  };
  // const loadOptionsSuggest = async (page = 0, search = "", data) => {
  //   return new Promise(async (resolve, reject) => {
  //     let dataBody = {
  //       table_id: 22587,
  //       start_index: page,
  //       type: "or",
  //     };

  //     let newData = {
  //       options: [],
  //       hasMore: false,
  //       additional: {
  //         page: 0,
  //       },
  //     };

  //     try {
  //       const response = await fetch(`${proxy()}/PXK/LĐB`, {
  //         method: "GET",
  //         headers: {
  //           Authorization: _token,
  //           "content-type": "application/json",
  //         },
  //         // body: JSON.stringify(dataBody),
  //       });

  //       if (!response.ok) {
  //         throw new Error(`Failed to fetch data: ${response.statusText}`);
  //       }

  //       const res = await response.json();
  //       const returnedData = res.data || [];
  //       const options = returnedData.map((d) => {
  //         if (data.child?.length) {
  //           let label = data.child
  //             .map(({ value }) => d[value])
  //             .filter(Boolean)
  //             .join("_");

  //           return {
  //             value: d,
  //             label: label,
  //           };
  //         }
  //         // return {
  //         //   value: d,
  //         //   label: d[pk],
  //         // };
  //       });

  //       const hasMoreValue = returnedData.length > 0;

  //       newData = {
  //         options: options,
  //         hasMore: hasMoreValue,
  //         additional: {
  //           page: hasMoreValue ? page + 15 : page,
  //         },
  //       };

  //       setTimeout(() => {
  //         resolve(filterData(newData, search));
  //       }, 100);
  //     } catch (error) {
  //       console.error("Error in loadOptions:", error);
  //       reject(error);
  //     }
  //   });
  // };

  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };

  return (
    <>
      <div
        key={resetForm}
        class="modal fade"
        id="renderModalTest"
        tabindex="-1"
        aria-labelledby="renderModalTest"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content custome">
            <div className="modal-header justify-content-start">
              <span style={{ fontSize: "18px" }}>{lang["add"]}</span>
              {/* <button
                type="button"
                class="close"
                data-dismiss="modal"
                onClick={() => setIsToggle(false)}
              >
                &times;
              </button> */}
            </div>
            <div
              className="modal-body"
              style={{
                height: "70vh",
                overflowY: "auto",
                overflowX: "unset",
              }}
            >
              <form
                className=""
                style={{
                  padding: "5px 5em",
                }}
              >
                {inputFields.map((item, _index) => {
                  return item?.isFK?.state && !item.isSuggest ? (
                    <>
                      <label className="form-label">{item.label}</label>{" "}
                      <div className="d-flex">
                        <AsyncPaginate
                          placeholder={lang["select value"]}
                          loadOptions={async (
                            search,
                            loadedOptions,
                            { page }
                          ) => {
                            return await loadOptions(
                              page,
                              search,
                              item?.isFK,
                              data
                            );
                          }}
                          onChange={async (opt) => {
                            setSelected(opt);
                            const value = item.isFK.child
                              .map((childItem) => {
                                if (
                                  childItem.alias &&
                                  opt.value[childItem.value]
                                ) {
                                  return {
                                    alias: childItem.alias,
                                    value: opt.value[childItem.value],
                                  };
                                }
                                return null;
                              })
                              .filter(Boolean);

                            const updatedValue = value.reduce((acc, curr) => {
                              acc[curr.alias] = curr.value;
                              return acc;
                            }, {});
                            const newData = {
                              ...updatedValue,
                              ...opt.value,
                            };
                            console.log("optsoptsopts", opt);

                            const { data: SanPham } = await fetch(
                              proxy() + `/api/PXK/inforLGH`,
                              {
                                method: "POST",
                                headers: {
                                  Authorization: _token,
                                  "content-type": "application/json",
                                },
                                body: JSON.stringify({
                                  msp: [
                                    opt.value?.["msp"] ||
                                      opt.value["28MSP"]?.MaSP ||
                                      opt.value["28MSP"],
                                  ],
                                }),
                              }
                            ).then((res) => res.json());
                            setTempValue({
                              alias: alias,
                              value: {
                                ...tempValue.value,
                                ...newData,
                                "25MSP": {
                                  TenSP: SanPham?.[0]?.TenSP,
                                  MaSP: SanPham?.[0]?.MaSP,
                                },
                              },
                            });
                            // setTempValue({
                            //   alias: alias,
                            //   value: {
                            //     ...tempValue.value,
                            //     alias: value,
                            //   },
                            // });
                          }}
                          isSearchable={true}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%",
                            }),
                            menuList: (base) => ({
                              ...base,
                              maxHeight: "300px",
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          additional={{
                            page: 0,
                          }}
                          noOptionsMessage={() => (
                            <div style={{ fontWeight: "300" }}>
                              {lang["not found data"]}
                            </div>
                          )}
                        />
                      </div>
                    </>
                  ) : item.type === "textarea" ? (
                    <>
                      <label className="form-label">{item.label}</label>
                      <textarea
                        className="form-control"
                        rows={5}
                        onChange={(e) => {
                          const { value } = e.target;
                          if (item.isParamSuggest) {
                            SetParamSuggest({
                              alias: item.alias,
                              param: paramSuggest,
                            });
                          }
                          setTempValue({
                            alias: alias,
                            value: {
                              ...tempValue.value,
                              [item.alias]: value,
                            },
                          });
                        }}
                      ></textarea>
                    </>
                  ) : (
                    <div className="mb-3 mt-3" key={_index}>
                      <label className="form-label">{item.label}</label>
                      <div className="d-flex">
                        {!item.isSuggest ? (
                          <input
                            type={item.type}
                            className="form-control"
                            placeholder=""
                            onBlur={(e) => {
                              const { value } = e.target;

                              if (item.alias === "4SLCXTT" && value) {
                                const roundedValue =
                                  parseFloat(value).toFixed(3);

                                setTempValue({
                                  alias: alias,
                                  value: {
                                    ...tempValue.value,
                                    [item.alias]: Number(roundedValue),
                                  },
                                });
                              }
                            }}
                            onChange={(e) => {
                              const { value } = e.target;
                              const numericValue = parseFloat(value);
                              if (!isNaN(numericValue) && numericValue < 0) {
                                setTempValue({
                                  alias: alias,
                                  value: {
                                    ...tempValue.value,
                                    [item.alias]: 0,
                                  },
                                });
                              } else {
                                if (item.isParamSuggest) {
                                  SetParamSuggest({
                                    param: value,
                                    alias: item.alias,
                                  });
                                  setDataSuggest([]);
                                  setSelectedSuggest([]);
                                }
                                setTempValue({
                                  alias: alias,
                                  value: {
                                    ...tempValue.value,
                                    [item.alias]: value,
                                  },
                                });
                              }
                            }}
                          />
                        ) : (
                          <Select
                            // loadOptions={async (
                            //   search,
                            //   loadedOptions,
                            //   { page }
                            // ) => {
                            //   return await loadOptionsSuggest(
                            //     page,
                            //     search,
                            //     item?.isFK
                            //   );
                            // }}
                            options={isData}
                            components={{
                              Option: CustomOption,
                            }}
                            value={selectedSuggest}
                            onChange={(options) => {
                              setSelectedSuggest(options);
                              const cal = options.map((item) => {
                                const { QC, SoLuong } = item;
                                const Tan = (SoLuong * QC) / 1000;
                                const params = paramSuggest.param;
                                const SoLuongCanLay =
                                  params - Tan > 0 ? Tan : params;
                                const SoBao =
                                  params - Tan > 0
                                    ? SoLuong
                                    : Math.ceil((params * 1000) / QC);
                                const SoTan = Tan - SoLuongCanLay;
                                return {
                                  ...item,
                                  SLX: `${SoBao} Bao\n${SoLuongCanLay} Tấn`,
                                  SLCX: `${SoLuong - SoBao} Bao\n${SoTan} Tấn`,
                                };
                              });
                              setDataSuggest(cal);
                              const mappedValue = [];
                              // const value = item.isFK.child
                              //   .map((childItem) => {
                              //     const matchingOpt = options.map(
                              //       (o) => o.value[childItem.value]
                              //     );
                              //     if (matchingOpt.length > 0) {
                              //       mappedValue.push({
                              //         alias: childItem.alias,
                              //         value: matchingOpt,
                              //       });
                              //     }
                              //     if (childItem.alias && matchingOpt) {
                              //       return {
                              //         alias: childItem.alias,
                              //         value: matchingOpt,
                              //       };
                              //     }
                              //   })
                              //   .filter(Boolean);

                              // const updatedValue = value.reduce((acc, curr) => {
                              //   acc[curr.alias] = curr.value;
                              //   return acc;
                              // }, {});

                              // const newData = {
                              //   ...updatedValue,
                              //   value: options,
                              // };

                              setTempValue({
                                alias: alias,
                                value: {
                                  ...tempValue.value,
                                  [item.alias]: options.map(
                                    (item) => item.label
                                  ),
                                  dataEdit: options.map((item) => item.value),
                                },
                              });
                            }}
                            isMulti
                            isSearchable={true}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: "100%",
                              }),
                              menuList: (base) => ({
                                ...base,
                                maxHeight: "300px",
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            additional={{
                              page: 0,
                            }}
                            noOptionsMessage={() => (
                              <div style={{ fontWeight: "300" }}>
                                {lang["not found data"]}
                              </div>
                            )}
                          />
                        )}
                        {item.isSuggest ? (
                          <>
                            <div
                              className="btn btn-success mt-0 ml-3"
                              onClick={() => handleCallDataSugges()}
                            >
                              Gợi Ý
                            </div>
                          </>
                        ) : null}
                      </div>
                      {item.isSuggest ? (
                        <div style={{ overflow: "auto" }}>
                          <Table className="table table-custom mt-3">
                            <thead>
                              <tr>
                                {item?.child?.map((header) => {
                                  return <td>{header.label}</td>;
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {dataSuggest &&
                                dataSuggest.length > 0 &&
                                dataSuggest.map((data, index) => {
                                  return (
                                    <tr key={index}>
                                      {item?.child?.map(({ alias, color }) => {
                                        return (
                                          <td
                                            style={{
                                              color: color,
                                              textAlign: "left",
                                              whiteSpace: "pre",
                                            }}
                                          >
                                            {data[alias]}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </Table>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setIsToggle(false)}
              >
                {lang["btn.close"]}
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                onClick={() => {
                  setRefreshPage((prev) => prev + 1);
                  setIsToggle(false);
                  if (Object.values(tempValue.value).length > 0) {
                    handleChange(
                      { alias: tempValue.alias },
                      { ...tempValue.value, label: selected.label }
                    );
                    setSelectedValues((prev) => [...prev, selected]);
                  }
                }}
              >
                {lang["btn.update"]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
